var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "shop-header", style: _vm.bgStyle }, [
        _c("div", { staticClass: "header-top" }, [
          _vm.configObj.logoConfig.url
            ? _c("img", {
                staticClass: "logo1",
                attrs: { src: _vm.configObj.logoConfig.url, alt: "" },
              })
            : _c("div", { staticClass: "logo1 logo-empty" }, [
                _vm._v("店铺logo"),
              ]),
          _c("div", { staticClass: "address", style: _vm.textStyle }, [
            _c("i", { staticClass: "el-icon-location-outline" }),
            _c("span", { staticClass: "line1" }, [
              _vm._v(_vm._s(_vm.configObj.addressConfig.val || "选择收货地址")),
            ]),
            _c("span", { staticClass: "self-tag" }, [_vm._v("自提点")]),
            _c("i", { staticClass: "el-icon-arrow-right arrow" }),
          ]),
        ]),
        _c("div", { staticClass: "header-search" }, [
          _c("div", { staticClass: "search-box", style: _vm.searchStyle }, [
            _c("i", { staticClass: "el-icon-search" }),
            _c("span", { staticClass: "ph line1" }, [
              _vm._v(_vm._s(_vm.hotWord)),
            ]),
            _c("span", { staticClass: "search-btn", style: _vm.btnStyle }, [
              _vm._v(_vm._s(_vm.configObj.searchBtnConfig.val || "搜索")),
            ]),
          ]),
        ]),
        _vm.tagList.length
          ? _c(
              "div",
              { staticClass: "header-tags" },
              _vm._l(_vm.tagList, function (tag, i) {
                return _c(
                  "span",
                  { key: i, staticClass: "tag", style: _vm.tagStyle },
                  [
                    tag.img
                      ? _c("img", {
                          staticClass: "tag-icon",
                          attrs: { src: tag.img, alt: "" },
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(tag.val) + " "),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }